import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDeviceAccessLimitation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 21,
	viewBox: "0 0 23 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.275 1.00696H5.725C4.54234 0.941118 3.38158 1.34442 2.49627 2.12884C1.61096 2.91325 1.07306 4.015 1 5.19345V11.4732C1.07306 12.6516 1.61096 13.7534 2.49627 14.5378C3.38158 15.3222 4.54234 15.7255 5.725 15.6597H17.275C18.4576 15.7255 19.6184 15.3222 20.5037 14.5378C21.389 13.7534 21.9269 12.6516 22 11.4732V5.19345C21.9269 4.015 21.389 2.91325 20.5037 2.12884C19.6184 1.34442 18.4576 0.941118 17.275 1.00696Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.334 15.6665V19.9998",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6667 20H7",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconDeviceAccessLimitation;
